import {
    Card,
    CardActionArea,
    Grid,
    Typography,
    useTheme,
} from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function KanisaHomeCard({ title, link, full, img, ...other }) {
    const navigate = useNavigate();
    const theme = useTheme();

    return (
        <Grid item xs={full ? 12 : 6} {...other}>
            <Card
                variant="outlined"
                style={{
                    padding: 0,
                    borderRadius: 10,
                    borderColor: theme.palette.background.default,
                    backgroundImage: `url('${img}')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >
                <CardActionArea
                    onClick={() => {
                        navigate(link);
                    }}
                    style={{
                        backgroundImage:
                            'linear-gradient(rgba(0,0,0,.1), rgba(0,0,0,1))',
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: 'flex-start',
                        padding: 8,
                        height: 150,
                        textAlign: 'left',
                    }}
                >
                    <Typography className="text-white" noWrap={false}>
                        {title}
                    </Typography>
                </CardActionArea>
            </Card>
        </Grid>
    );
}
